<template>
  <el-aside class="aside-bar" width="219px">
    <div class="hi_icon">
      <template v-if="hasLogin">
        <a
          class="pointer text-theme"
          @click.prevent.stop="$router.push('/user/detail')"
        >{{nickname}}</a>
        <div class="u-text-right u-font-16">Welcome back.</div>
      </template>
      <template v-else>
        <span class="pointer text-theme">Welcome to manybo</span>
        <p class="u-text-right u-font-16">manybo.com</p>
      </template>
    </div>

    <el-menu
      v-if="hasLogin"
      :default-active="$route.path"
      background-color="#f8f8f8"
      :default-openeds="openeds"
      :router="true"
    >
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>{{ $t('aside.first.name') }}</span>
        </template>
        <el-menu-item index="/jiyun">
          <template slot="title">
            <i class="el-icon-mb-package"></i>
            <span>{{ $t('aside.first.children[0]') }}</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/order">
          <template slot="title">
            <i class="el-icon-mb-order"></i>
            <span>{{ $t('aside.first.children[1]') }}</span>
          </template>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>{{ $t('aside.third.name') }}</span>
        </template>

        <el-menu-item index="/user/account">
          <template slot="title">
            <i class="el-icon-user"></i>
            <span>{{ $t('aside.third.children[0]') }}</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/user/warehouse">
          <template slot="title">
            <i class="el-icon-map-location"></i>
            <span>{{ $t('aside.third.children[1]') }}</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/user/address">
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>{{ $t('aside.third.children[2]') }}</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/user/coupon">
          <template slot="title">
            <i class="el-icon-money"></i>
            <span>{{ $t('aside.third.children[5]') }}</span>
          </template>
        </el-menu-item>


        <el-menu-item index="/user/exchange">
          <template slot="title">
            <i class="el-icon-coin"></i>
            <span>{{ $t('aside.third.children[3]') }}</span>
          </template>
        </el-menu-item>
        
        <el-menu-item @click.native.stop="logout">
          <template slot="title">
            <i class="el-icon-back"></i>
            <span>{{ $t('aside.third.children[4]') }}</span>
          </template>
        </el-menu-item>
      </el-submenu>
    </el-menu>

    <asideInfo />
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex'

import asideInfo from './mixin/aside'
export default {
  components: {
    asideInfo,
  },
  methods: {
    logout() {
      this.$store.dispatch('user/LogOut').then(() => {
        //location.reload() // 为了重新实例化vue-router对象 避免bug
        // this.$router.push('/')//不用跳，路由守卫自动处理
      })
    },
  },

  data() {
    return {
      openeds: ['1', '2', '3'],
    }
  },

  computed: {
    ...mapGetters(['hasLogin', 'nickname']),
  },
}
</script>

<style lang="scss" scoped>
.el-menu ::v-deep{
	border: none;
}
.aside-bar {
  background: url('../../assets/img/logo2.png') #f8f8f8 left top no-repeat;
  position: relative;
  padding: 300px 0 0 0;
  .hi_icon {
    position: absolute;
    top: 150px;
    left: 0;
    padding: 80px 0 0 0;
    width: 100%;
    overflow: hidden;
    font-style: italic;
    font-weight: lighter;
    text-align: center;
    background: url('../../assets/img/icon008.png') 150px 0px no-repeat;
    div {
      font-size: 12px;
      margin: 5px 10px 0 0;
      color: #ccc;
      text-align: right;
    }
  }
}
</style>